// test1988
(1988 && 0);
